import React from 'react';
import './CourseDetailsCard.css';
import { IconStack2, IconBooks, IconCertificate, IconDeviceLaptop } from '@tabler/icons-react';
import { Badge, Button } from '@mantine/core';
import CardFeature from "../../../components/CardFeature/CardFeature";
import { currencyFormat } from "../../../utils/currencyFormat";
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../context/AppState/AppContext';
import CourseCardModal from './CourseCardModal/CourseCardModal';
import { formattedPrice } from '../../../utils/formatted-price';



function CourseDetailsCard(props) {
    const { price, features = null, handleInscription, isOpen, courseData, courseDetailsCard } = props;
    const { badgeTitle, courseCardModal, inscriptionButton, contactButton, defaultFeatures } = courseDetailsCard;
    const { isUSD } = useAppContext();
    const navigate = useNavigate();
    const { jsonBranding, jsonColors } = useAppContext()
    const institutionName = jsonBranding?.institutionalName

    const getIconByText = (text) => {
        //For now, created a switch with the different cases referring to an specificy text to render an icon. Need to be reviewed when improving icons behaviour for ForTech.
        switch (text) {
            case "Modalidad 100% online":
                return <IconStack2 className="cardFeature__icon" />;
            case "Material de soporte para el curso":
                return <IconBooks className="cardFeature__icon" />;
            case `Certificado emitido por ${institutionName}`:
                return <IconCertificate className="cardFeature__icon" />;
            case "Clases grabadas":
                return <IconDeviceLaptop className="cardFeature__icon" />;
            default:
                return null;
        }
    };

    return (
        <div className="courseDetailsCard__container">
            <span className="courseDetailsCard__price">{formattedPrice(currencyFormat(price), isUSD)}</span>
            <Badge
                classNames={{ root: "courseDetailsCard__badge" }}
                variant="light" size="md" radius="sm"
            >
                {isOpen ? badgeTitle.open : badgeTitle.closed}
            </Badge>

            <CourseCardModal disabled={!isOpen} courseCardModal={courseCardModal} />

            <hr />
            {features.map((item, index) => (
                <CardFeature
                    key={index}
                    icon={item.icon}
                    text={item.text}
                    description={item.description}
                />
            ))}

            <hr />
            <div className="courseDetailsCard__button__container">
                <Button className="courseDetailsCard__button" color={'var(--color-tertiary)'} fw='normal' disabled={!isOpen} fullWidth onClick={() => handleInscription()}>
                    {inscriptionButton}
                </Button>
                <Button className="courseDetailsCard__button" fw='normal' fullWidth
                    variant="default" onClick={() => navigate("/contacto", { state: courseData })}>
                    {contactButton}
                </Button>
            </div>
            <hr className="courseDetailsCard__hr" />

            {defaultFeatures.map((item, index) => (
                <CardFeature
                    key={index}
                    icon={getIconByText(item.text)}
                    text={item.text}
                />
            ))}
        </div>
    );
}

export default CourseDetailsCard;